import * as R from 'ramda'

import { categoryNames } from 'components/common/JobProfileWidget/text'
import { getDisplayCompetencies } from 'utils/categories'
import { getLanguages } from 'utils/languages'

const getPickedCompetencies = competencies =>
  R.pipe(
    R.toPairs,
    R.filter(([name, value]) => R.and(R.equals(value, R.T()), name)),
    R.map(([name]) => name),
  )(competencies)

const getLabels = R.pipe(
  R.toPairs,
  R.map(([name, [label]]) => ({ label, name })),
)

export const getLanguageLabels = languages => {
  const labels = getLanguages()

  return R.pipe(
    R.filter(({ label, value }) => R.and(R.includes(value, languages), label)),
    R.map(({ label }) => label),
    R.join(', '),
  )(labels)
}

export const getCompetenciesLabels = (competencies, language) => {
  const names = getPickedCompetencies(competencies)
  const labels = getLabels(categoryNames(language))

  const selectedLabels = R.pipe(
    R.filter(({ name }) => R.includes(name, names)),
    R.map(({ label }) => label),
  )(labels)

  return selectedLabels.map((label, idx) =>
    idx < selectedLabels.length - 1 ? `${label},` : label,
  )
}

const withSeparators = labels =>
  labels.map((label, idx) => (idx < labels.length - 1 ? `${label},` : label))

/**
 * The competency labels to show for a job profile.
 *
 * A profile can name the competencies its report presents, in which case they
 * are shown in the order it lists them. Otherwise the competencies selected for
 * scoring are shown, as they always have been.
 */
export const getProfileCompetenciesLabels = (profile, language) => {
  const shown = getDisplayCompetencies(profile)

  if (!shown) {
    return getCompetenciesLabels(profile?.categories, language)
  }

  const names = categoryNames(language)

  return withSeparators(
    shown.map(name => R.head(R.propOr([], name, names))).filter(Boolean),
  )
}
